import * as numeral from 'numeral';
import * as _ from 'underscore';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import * as $ from 'jquery';

export interface CTVNetwork {
	networkName: string;
	logoPath: string;
	impressions: number;
	completionRate: number;
}

@Component({
	selector: 'app-featured-networks-r10',
	templateUrl: './featured-networks-r10.component.html',
	styleUrls: ['./featured-networks-r10.component.css']
})
export class FeaturedNetworksR10Component implements OnInit {
	@Input() downloadconfig: any;
	@Input() sectionclass: any;
	@Input() defaultsort: string;
	@Input() sectiontitle: string;
	@Input() columnsconfig: any;
	public key: string;
	public columns: any;
	showLoad = false;
	public hasData: boolean;
	public featuredNetworks: CTVNetwork[] = [];
	public reloadSubscription;
	public widgetDataSubscription;
	public p2: any;
	public isR10Config: boolean = false;
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.p2 = 1;
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.requestData();
		this.columns = JSON.parse(decodeURI(this.columnsconfig));
		this.isR10Config = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processWidgetRequest(this.key, this.columns)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}

	processResponseData(response: any): void {
		this.featuredNetworks = this.mapCTVNetworkResponseToInterface(response);
		if (!this.defaultsort) {
			this.featuredNetworks = _.sortBy(this.featuredNetworks, 'impressions').reverse();
		}
	}

	mapCTVNetworkResponseToInterface(responseArray: any[]): CTVNetwork[] {
		const ctvNetworks: CTVNetwork[] = [];
		for (const responseObj of responseArray) {
			const ctvNetwork: CTVNetwork = {} as CTVNetwork;
			ctvNetwork.networkName = !UtilityService.isUndefinedOrNull(responseObj.network_name)
				? responseObj.network_name
				: responseObj.name;
			ctvNetwork.logoPath = responseObj.logo_path;
			ctvNetwork.impressions = !UtilityService.isUndefinedOrNull(responseObj.impressions)
				? parseInt(responseObj.impressions, 10)
				: 0;
			ctvNetwork.completionRate = UtilityService.isUndefinedOrNull(responseObj.completions_rate)
				? parseFloat(responseObj['100_completions_rate'])
				: responseObj.completions_rate;
			ctvNetworks.push(ctvNetwork);
		}
		_.sortBy(ctvNetworks, (ctvNetwork) => {
			return ctvNetwork.completionRate;
		});
		return ctvNetworks;
	}
}
